import { useMemo } from 'react';

import { RouteManager } from '../../../RouteManager';

import { useDevice } from '../../../store/devices/useDevices.ts';
import { useApi } from '../../../store/SelectedHomeyStore.hooks.ts';
import { useZone } from '../../../store/zones/useZones.ts';

import { HomeyColors } from '../../../theme/HomeyColors';

import { getOverrideURL } from '../../../components/device/DeviceIcon';

export function DeviceFlowCard(props) {
  const { component: Component, ...rest } = props;
  const { api } = useApi();
  const { device } = useDevice({ deviceId: props.ownerId });
  const { zone } = useZone({ zoneId: device?.zone });

  const { iconUrl, iconObj, iconBackgroundColor, resourceUrl, name, isLocked } = useMemo(() => {
    const result = {
      iconUrl: null,
      iconObj: null,
      iconBackgroundColor: HomeyColors.getColorForUri('homey:manager:devices'),
      resourceUrl: null,
      name: props.ownerUri,
      isLocked:
        (props.card.requiresPremium === true || device?.requiresPremium === true) &&
        api.tier !== 'premium',
    };

    if (device != null) {
      result.name = device.name;
      result.iconObj = device.iconObj;
      result.resourceUrl = RouteManager.getPathForDevice(device.id);

      if (device.color != null) {
        result.iconBackgroundColor = device.color;
      }

      if (device.iconOverride != null) {
        result.iconUrl = getOverrideURL({ iconOverride: device.iconOverride });
      }
    }

    if (zone != null) {
      result.name = `${result.name} - ${zone.name}`;
    }

    return result;
  }, [device, zone, props.card, props.ownerUri, api]);

  return (
    <Component
      {...rest}
      iconUrl={iconUrl}
      iconObj={iconObj}
      iconBackgroundColor={iconBackgroundColor}
      resourceUrl={resourceUrl}
      name={name}
      isLocked={isLocked}
    />
  );
}
